import { getSalawat } from '@sayfazkari/content';
import { useSalawat } from '../../store/salawat';
import { useSession } from '../../store/session';
import { SalawatCounter } from './SalawatCounter';
import { ru } from '../../strings/ru';
import styles from './SalawatScreen.module.css';

export function SalawatScreen() {
  const today = useSalawat((s) => s.today);
  const total = useSalawat((s) => s.total);
  const tap = useSalawat((s) => s.tap);
  const resetToday = useSalawat((s) => s.resetToday);
  const exitSession = useSession((s) => s.exitSession);
  const showTranslit = useSession((s) => s.settings.showTranslit);
  const showTranslation = useSession((s) => s.settings.showTranslation);

  const text = getSalawat();

  return (
    <div className={styles.screen}>
      <div className={styles.top}>
        <button
          className={styles.exitBtn}
          onClick={exitSession}
          aria-label={ru.session.exitHint}
        >
          <span aria-hidden="true">←</span> {ru.session.exit}
        </button>
        <h1 className={styles.title}>{ru.salawat.title}</h1>
      </div>

      <div className={styles.scroll}>
        {text ? (
          <article className={styles.card}>
            <p className={styles.arabic} dir="rtl" lang="ar">
              {text.arabic}
            </p>
            {showTranslit && text.translit && (
              <p className={styles.translit}>{text.translit}</p>
            )}
            {showTranslation && text.translationRu && (
              <p className={styles.translation}>{text.translationRu}</p>
            )}
            {text.source && (
              <p className={styles.source}>
                <span className={styles.lbl}>{ru.session.source}</span>{' '}
                {text.source.refRu}
              </p>
            )}
          </article>
        ) : (
          /* Текст не задан — счётчик всё равно работает. Придумывать
             арабский нельзя, поэтому честно говорим, что текста нет. */
          <p className={styles.noText}>{ru.salawat.noText}</p>
        )}

        <dl className={styles.stats}>
          <div className={styles.stat}>
            <dt>{ru.salawat.today}</dt>
            <dd>{today}</dd>
          </div>
          <div className={styles.stat}>
            <dt>{ru.salawat.total}</dt>
            <dd>{total}</dd>
          </div>
        </dl>

        {today > 0 && (
          <button className={styles.reset} onClick={resetToday}>
            {ru.salawat.resetToday}
          </button>
        )}
      </div>

      <div className={styles.bottom}>
        <SalawatCounter today={today} onTap={tap} />
      </div>
    </div>
  );
}
